import StaticWebPage, { getStaticPagesProps } from '../page-components/sp/sp';

export default StaticWebPage;

export const getServerSideProps = getStaticPagesProps;
